import buttonConfig from '../../../packages/button/src/formConfig';
export default buttonConfig;
